import { render, staticRenderFns } from "./part_3.vue?vue&type=template&id=62d1fb42&scoped=true&"
import script from "./part_3.vue?vue&type=script&lang=js&"
export * from "./part_3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d1fb42",
  null
  
)

export default component.exports